import styled from "styled-components";

export const BasketCardFooterContainer = styled.div``;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  border-top: 1px solid #dee1e3;
  margin-bottom: 25px;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-weight: bold;
  row-gap: 25px;
`;

export const BookingData = styled.div`
  ul {
    list-style-type: disc;
    list-style-position: inside;
  }
`;

export const LinkAndIconContainer = styled.div`
  display: flex;
  gap: 12px;
`;
